import { GridModel } from '@/models';

export class TraceReportViewModel extends GridModel {
  constructor() {
    super();
  }

  public get headers() {
    return [
      {
        text: 'Request Id',
        align: 'left',
        sortable: false,
        value: 'requestId'
      },
      {
        text: 'Ngb Id',
        align: 'left',
        sortable: false,
        value: 'ngbid'
      },
      {
        text: 'Portal/Instance',
        align: 'left',
        sortable: false,
        value: ''
      },
      {
        text: 'Start',
        align: 'left',
        sortable: false,
        value: 'stateTime'
      },
      {
        text: 'End',
        align: 'left',
        sortable: false,
        value: 'endTime'
      },
      {
        text: 'Request Status',
        align: 'left',
        sortable: false,
        value: 'lastName'
      },
      {
        text: 'Order Status',
        align: 'left',
        sortable: false,
        value: 'lastName'
      },
      {
        text: '',
        align: 'left',
        sortable: false,
        value: 'lastName'
      }
    ];
  }
}
